/**
 * @Description 是否正在使用工具箱的卫星地图
 */
import { useEffect, useContext, useState } from 'react';
import MapHelpfulContext from '@/common/components/AMap/MapHelpfulContext';

export function useSatellite() {
  const helpfulContext: any = useContext(MapHelpfulContext);
  const [isSatellite, setIsSatellite] = useState<boolean>(false); // 是否在使用测距功能


  useEffect(() => {
    const { stateData } = helpfulContext || {};
    const { toolBox } = stateData || {};
    const { satellite } = toolBox || {};
    setIsSatellite(!!satellite?.value);
  }, [helpfulContext?.stateData]);

  return isSatellite;
}
